import React from "react";
import PaperGradientBG from "../kits/DesignKit/PaperGradientBG"
// ggf. Pfad anpassen
import ContactForm from "./ContactForm"; // ggf. Pfad anpassen

/**
 * ZenDemoFooter
 * Manifest-Section + Demo/Contact CTA in ruhiger ZenBlack-Fläche.
 */
const ZenDemoFooter = ({
  title = (
    <>
      Systeme entstehen aus Haltung,<br />nicht aus Modulen
    </>
  ),
  intro = (
    <>
      Ein gutes System fühlt sich nicht wie Software an. Es ordnet Wissen,
      macht Fortschritt sichtbar und nimmt Menschen ernst – auf beiden Seiten.
    </>
  ),
  body = (
    <>
      Ich entwickle individuelle Plattformen, in denen Kurse, Fähigkeiten,
      Projekte und Nachweise logisch zusammengehören. Klar aufgebaut, wartbar
      gedacht und so reduziert, dass sie langfristig tragfähig bleiben.
    </>
  ),
  showBorder = true,
  borderClassName = "border-1 border-brand",
  className = "",
  children, // falls du statt ContactForm was anderes reinlegen willst
}) => {
  return (
    <PaperGradientBG
      variant="zen151515"
      className={`rounded-2xl overflow-hidden mt-10 ${showBorder ? borderClassName : ""} ${className}`}
    >
      <section className="px-8 py-24 text-[#D9D4C5]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-sm sm:text-base font-semibold mb-8 tracking-tight text-brand">
            {title}
          </h2>

          <p className="text-sm sm:text-base font-mono fomtWeight-200 text-gray-300 leading-relaxed mb-6">
            {intro}
          </p>

          <p className="text-base md:text-lg text-gray-300 leading-relaxed">
            {body}
          </p>

          <div className="mt-10">
            {children ? children : <ContactForm />}
          </div>
        </div>
      </section>
    </PaperGradientBG>
  );
};

export default ZenDemoFooter;
